import { render, staticRenderFns } from "./accountAvatar.vue?vue&type=template&id=d3b818a8&"
import script from "./accountAvatar.vue?vue&type=script&lang=ts&"
export * from "./accountAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports